import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-setting",
  "use": "icon-setting-usage",
  "viewBox": "0 0 21.375 24.750001907348633",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 21.375 24.750001907348633\" id=\"icon-setting\"><g><path d=\"M10.6875,0L21.375,6.1875L21.375,18.5625L10.6875,24.75L0,18.5625L0,6.1875L10.6875,0ZM10.6875,15.75C12.5515,15.75,14.0625,14.239,14.0625,12.375C14.0625,10.511,12.5515,9,10.6875,9C8.82354,9,7.3125,10.511,7.3125,12.375C7.3125,14.239,8.82354,15.75,10.6875,15.75Z\" fill=\"#FFFFFF\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol